import React, { useEffect, useMemo, useState } from "react";
import PaymentTable from "./PaymentTable";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getPayments } from "../../redux//actions/paymentAction";
 
const PaymentHistory = () => {
    const history = useNavigate();
    const dispatch = useDispatch();
    const allPayments = useSelector((state) => state.payment.allPayments);
    const pagination = useSelector((state) => state.payment.pagination);
 
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({ page: 1, limit: 50, search: "", platform: "", source: "", from: "", to: "" });
    const query = useMemo(() => Object.fromEntries(Object.entries(filters).filter(([, value]) => value !== "")), [filters]);
    const updateFilters = (updates) => setFilters((current) => ({ ...current, ...updates, page: updates.page || 1 }));

    useEffect(() => {
        const timer = setTimeout(() => dispatch(getPayments(query, setLoading)), 300);
        return () => clearTimeout(timer);
    }, [dispatch, query]);
 
    return (
        <PaymentTable
            heading="Payment History"
            allPayments={allPayments}
            loading={loading}
            history={history}
            filters={filters}
            setFilters={updateFilters}
            pagination={pagination}
        />
    );
};
 
export default PaymentHistory;
